import { Dialog } from '@ordr-as/umami-react/dialog';
import type { FC } from 'react';
import type { MenuItemVariantDto } from '../../../../../../../generated-api/models/MenuItemVariantDto';
import { useScreenSize } from '../../../../../../context/ScreenSizeContext';

interface Props {
  item: MenuItemVariantDto;
  onClose: () => void;
}

const ItemDetailsModal: FC<Props> = ({ item, onClose }) => {
  const { isPhone } = useScreenSize();

  return (
    <Dialog onClose={onClose} title={item.name} size={isPhone ? 'fullwidth' : 'default'}>
      <article className="flex flex-col gap-6">
        <section>
          <p className="mb-3">{item.description}</p>
          <p className="text-grey-dark text-small">{item.allergens.map((a) => a.name).join(', ')}</p>
        </section>
      </article>
    </Dialog>
  );
};
export default ItemDetailsModal;
